import React, {useState} from "react";
import Logo from "../media/logo.svg";
import { Link } from "react-router-dom";
import { updateUser } from "../utilities/servicesTrackWeb";
import useTrackWebContext from "../hooks/useTrackWebContext";

const UserEdit = () => {
  const { infoCommerce, token } = useTrackWebContext();
  const [newEmail, setNewEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newEmail !== confirmEmail) {
      setError("Los emails no coinciden");
      return;
    }

    try {
      await updateUser(infoCommerce.id, token, newEmail);
      setSuccessMessage("Email actualizado con éxito.");
      setError("");
    } catch (err) {
      setError("Hubo un error al actualizar el email.");
    }
  };
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4">
      <img src={Logo} className="w-52 mt-4 mb-6" alt="Club La Voz" />

      <form onSubmit={handleSubmit} className="w-full max-w-md">
        <h3 className="text-center font-body text-gray-900 font-bold text-2xl pt-4 pb-2">
          Editar Perfil
        </h3>

        <div className="my-4">
          <label className="font-body font-normal">Nuevo email</label>
          <input
            type="text"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            className="w-full my-2 pl-5 py-2 rounded-full border border-gray-500 bg-white placeholder-gray-500 font-body focus:bg-neutral-50 focus:border-clvblue"
            placeholder="Nuevo email"
          />
        </div>

        <div className="my-4">
          <label className="font-body font-normal">Confirmar nuevo email</label>
          <input
            type="text"
            value={confirmEmail}
            onChange={(e) => setConfirmEmail(e.target.value)}
            className="w-full my-2 pl-5 py-2 rounded-full border border-gray-500 bg-white placeholder-gray-500 font-body focus:bg-neutral-50 focus:border-clvblue"
            placeholder="Repetir email"
          />
        </div>

        {error && <p className="text-red-500 text-center">{error}</p>}
        {successMessage && <p className="text-green-500 text-center">{successMessage}</p>}

        <div className="mt-4 mb-6 w-full flex flex-col md:flex-row justify-between items-center gap-4">
          <Link to="/">
            <button className="w-full md:w-56 h-10 flex justify-center items-center px-4 py-1 border border-clvblue rounded-full text-clvblue text-xl font-body font-bold">
              Cancelar
            </button>
          </Link>
          <input
            type="submit"
            className="w-full md:w-56 h-10 flex justify-center items-center md:ml-2 md:mt-0 mt-2 px-4 py-1 bg-clvblue border-0 rounded-full text-white text-xl font-body font-bold hover:bg-[#C2CBDF] hover:border-2 hover:border-clvblue hover:text-clvblue"
            value="Actualizar Datos"
          />
        </div>
      </form>
    </div>
  );
};

export default UserEdit;
